import { render, staticRenderFns } from "./IfFeature.vue?vue&type=template&id=63b04054&scoped=true"
import script from "./IfFeature.vue?vue&type=script&lang=js"
export * from "./IfFeature.vue?vue&type=script&lang=js"
import style0 from "./IfFeature.vue?vue&type=style&index=0&id=63b04054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b04054",
  null
  
)

export default component.exports